// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorStub_container__1muTV","text":"ErrorStub_text__NtxdH"};